export default 'm13 15-3-3-6 3 7-7 3 3 6-3zM12 0C5.37 0 0 4.93 0 11c0 3.47 1.76 6.56 4.5 8.58V24l4.32-2.4q1.53.39 3.18.4c6.63 0 12-4.92 12-11S18.63 0 12 0';